import { eTipoPermissao } from "@/enums/ePermissoes";

export default [
 {
  description: "Solicitação para Reposição Central",
  path: "/merenda/mersolicitacaocentral",
  name: "mersolicitacaocentral",
  component: () => import("@/views/merenda/mersolicitacaocentral/Index.vue"),
  meta: {
   permissions: [eTipoPermissao.SOLICITACAOREPOSICAOCENTRALNOVO_MENU_1900300399],
  },
  goesToMenu: true,
 },
 {
  description: "Cadastro de Solicitação para Reposição Central",
  path: "/merenda/mersolicitacaocentral/cadastro/:id?",
  parent: "mersolicitacaocentral",
  name: "mersolicitacaocentral_create",
  component: () => import("@/views/merenda/mersolicitacaocentral/InclusaoEdicao.vue"),
  meta: {
   permissions: [eTipoPermissao.SOLICITACAOREPOSICAOCENTRALNOVO_MENU_1900300399],
  },
  goesToMenu: true,
 },
 {
  description: "Itens da Solicitação para Reposição Central",
  path: "/merenda/mersolicitacaocentral/:id/itens",
  parent: "mersolicitacaocentral",
  name: "mersolicitacaocentral_itens",
  component: () => import("@/views/merenda/mersolicitacaocentral/Itens.vue"),
  meta: {
   permissions: [eTipoPermissao.SOLICITACAOREPOSICAOCENTRALNOVO_MENU_1900300399],
  },
  goesToMenu: false,
 },
]
